export let cssIssueOccurrence = 0;
export default function trackDisplayContentsOccurrence(element) {
  const computedStyle = window.getComputedStyle(element);
  if (computedStyle.display === 'contents') {
    cssIssueOccurrence++;
  }
}
export function resetCssIssueOccurrence() {
  cssIssueOccurrence = 0;
}